
Mindbreeze.define('lht.components/init',["client/application", "jquery", "component!map", "underscore", "service/channels"], function (Application, $, Map, _, Channels) {

  var originalPrepareRequest = Channels.prototype.prepareRequest;
  Channels.prototype.prepareRequest = function (channel, request) {
    request.orderby = "sortPriority";
    request.order_direction = "DESCENDING";

    var orderby = $(document.body).attr("data-orderby"), 
		orderdirection = $(document.body).attr("data-orderdirection");
    if(orderby && orderdirection) {
      request.orderby = orderby;
      request.order_direction = orderdirection;
    }

    return originalPrepareRequest.apply(this, arguments);
  }


  window.srScroll = function () {
    var width = $(document.body).css("width");
    if (parseInt(width, 10) <= 500) return;
                var mapEl = $('div[data-template="map"]');
                var mapOffset = mapEl[0].getBoundingClientRect().top + window.scrollY;
    var fadeElemen = $(".media-body");
    var currScrollPos = $(this).scrollTop();
    fadeElemen.each(function () {
      var $this = $(this),
        elemOffsetTop = $this.offset().top;
      if (elemOffsetTop - mapOffset > 550-133) $this.css("opacity", 0.1);
      else $this.css("opacity", 1);
    });
  };

  $(".sr").scroll(window.srScroll);


  var origApplicationToggleExpandable = Application.prototype.toggleExpandable;
  Application.prototype.toggleExpandable = function (options) {
    if (options && options.event && options.event.handled) return
    else if (options && options.event) options.event.handled = true

    origApplicationToggleExpandable.apply(this, arguments);
  };

  var map;
  var moveendSet = false;
  var locationsPoints = {};


  var application = new Application({
    enableSourceInfo: false,
    enableUserSourceInfo: false
  });
  application.execute(function (application) {

    application.models.tabs.on("change", function (options) {
      window.executeSearch = false;
      window.tabChange = true;
      /*this.options.application.models.search.set("constraint", {
        unparsed: "ALL"
      });*/
      if (options.changed.selected) $("#breadcrumb").html(options.id);
    });

    application.models.search.on("computed", function () {
      window.tabChange = false;
      window.executeSearch = false;
      window.regionChange = false;

      window.srScroll();

      _.each(_.values(application.models.search.resultProperties),function(r) {
        r.trigger("updateMap");
      });
    });
  });

  function moveend() {
    if (window.tabChange || window.regionChange) return;
    var bounds = map.getBounds();
    var from_lat = bounds._southWest.lat,
      to_lat = bounds._northEast.lat,
      from_long = bounds._southWest.lng,
      to_long = bounds._northEast.lng;

    if (from_lat === to_lat || from_long === to_long) return;

    // prevent function from being called multiple times
    if (window.bounds === from_lat + " " + to_lat + " " + from_long + " " + to_long) {
      return;
    }

    window.bounds = from_lat + " " + to_lat + " " + from_long + " " + to_long;

    _.each(application.models.search.get("resultset").results, function (el) {
      var key = el.properties["mes:key"].data[0].value.str || el.properties["mes:key"].data[0].value;
      if (parseFloat(el.properties.geo_longitude.data[0].value) >= from_long && parseFloat(el.properties.geo_longitude.data[0].value) <= to_long &&
        parseFloat(el.properties.geo_latitude.data[0].value) >= from_lat && parseFloat(el.properties.geo_latitude.data[0].value) <= to_lat) {
        $("[data-result-id='" + key + "']").parent().show();
      } else {
        $("[data-result-id='" + key + "']").parent().hide();
      }
    });
    window.srScroll();

    //console.log("search set");
    /*  application.models.search.set("constraint", {
       unparsed: "geo_longitude_int:[" + from_long + " TO " + to_long + "] AND geo_latitude_int:[" + from_lat + " TO " + to_lat + "]"
     }); */

  }

 /* function degreesToRadians(degrees) {
    return degrees * Math.PI / 180;
  }
  
  function distanceInKmBetweenEarthCoordinates(lat1, lon1, lat2, lon2) {
    var earthRadiusKm = 6371;
  
    var dLat = degreesToRadians(lat2-lat1);
    var dLon = degreesToRadians(lon2-lon1);
  
    lat1 = degreesToRadians(lat1);
    lat2 = degreesToRadians(lat2);
  
    var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
    return earthRadiusKm * c;
  }

  function findNeighboursToPoint(point, points, maxDistanceKm) {
    var count = 0;
    _.each(points,function(p) {
      if(distanceInKmBetweenEarthCoordinates(p.lat,point.lat,p.lng,point.lng) >= maxDistanceKm) count++;
    });
    return count;    
  }*/

  function selectRegionChange() {
    var unparsed = $("#selectRegion option:selected").val();    
    application.models.search.set("constraint", {
      unparsed: "area:" + unparsed
    });
    $("#breadcrumb").html($("#selectRegion option:selected").text());
    window.regionChange = true;
  }
  window.selectRegionChange = selectRegionChange;

  function selectResult(name) {
    var currentZoom = 18//map.getZoom() + 1;
    if(currentZoom < 10) currentZoom = 10;
    map.setView(locationsPoints[name].latLng, currentZoom);
    locationsPoints[name].m.openPopup();
  }
  window.selectResult = selectResult;


  Map.View.prototype.addTileLayer = function () {
    var OpenStreetMap_DE = L.tileLayer('https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png', {
      maxZoom: 18,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    });
  
    OpenStreetMap_DE.addTo(this.map);
  }

  /** Changes in map.js necessary !!! **/
  Map.View.prototype.getIconDefaultImagePath = function () {
    return "./img";
  };

  var origAddOne = Map.View.prototype.addOne;
  Map.View.prototype.addOne = function () {
    //this.update();
  };

  var origSetModel = Map.View.prototype.setModel;
  Map.View.prototype.setModel = function() {
    origSetModel.apply(this,arguments);
    this.listenTo(this.collection, 'updateMap', this.update);
  }  

  var origRender = Map.View.prototype.render;
  Map.View.prototype.render = function () {
    origRender.apply(this, arguments);
    if (!map) map = this.map;
    this.mapEl.style.height = "500px";
  }

  /** Adapt for changes of clustering **/
  Map.View.prototype.update = function () {

    /* var defIcon = L.icon({
      iconUrl: 'img/icon-location-blue.svg',  
      iconSize:     [28, 39], // size of the icon 
      shadowSize:   [0, 0]  
    });
    var selIcon = L.icon({
      iconUrl: 'img/icon-location-yellow.svg',  
      iconSize:     [35, 45], // size of the icon    
      shadowSize:   [0, 0]
    }); */
    var defIcon = L.divIcon({
      className: 'defIcon'
    });
    var selIcon = L.divIcon({
      className: 'selIcon'
    });


    // console.log("update");
    try {
      var that = this,
        visible = false;

      if (this.markerGroup) this.markerGroup.clearLayers();

      var clusterGroups = L.markerClusterGroup({disableClusteringAtZoom:18});
      var markersList = [];

      _.each(this.collection.models, function (model) {
        var title = model.get("title"),
          href = model.get("actions[0].href"),
          latitude = model.get("geo_latitude"),
          longitude = model.get("geo_longitude"),
          country = model.get("country"),
          region = model.get("region");

        if (!latitude || !longitude) return false;

        if ((latitude >= -90) && (latitude <= 90) && (longitude >= -180) && (longitude <= 180)) {

        
          function closePopup() {
            if (parseInt($(document.body).css("width"), 10) > 500) {
              $("[data-template='results']").show();
            }
            $("#popupSubstitute").css("display", "none");
            $(".arrow-up").hide();
            $(".arrow-right").hide();
          }

          function popupOpen(m) {

           /* var points = _.pluck(locationsPoints,"latLng");
            var count = findNeighboursToPoint(m.target._latLng, points, 10);
            console.log(count); */
            /*window.i = 0;
             if(m.target._preSpiderfyLatlng) {				
              _.each(_.pluck(_.values(locationsPoints),"latLng"),function(ll) {
                if(ll.lat === m.target._preSpiderfyLatlng.lat && ll.lng === m.target._preSpiderfyLatlng.lng) { window.i++; }
              });
            } */

            var marker = m;
            if (m.target) marker = m.target;
            $("#popupSubstitute").html("<div class='close popupClose' style='padding-right: 10px;padding-top: 10px;'>X</div><div style='padding:20px'>" + marker.getPopup().getContent().outerHTML + "</div>");
            $("#popupSubstitute").css("display", "block");
            if (parseInt($(document.body).css("width"), 10) > 500) {
              $(".arrow-right").css("display", "block");
              $("[data-template='results']").hide();
            } else {
              $(".arrow-up").css("display", "block");
            }
            // $("#popupSubstitute").css("padding","20px");
            marker.setIcon(selIcon);
            $(".popupClose").on("click", function () {
              map.closePopup(marker._popup);
            })
          }
          window.popupOpen = popupOpen;



          that.render();
          visible = true;
          var latLng = new L.LatLng(latitude, longitude);

          // if (that.map) {
          //  that.map.invalidateSize();
          // }
          that.show();
          // L.marker(latLng).addTo(that.markerGroup).bindPopup(that.renderMarker(model)).openPopup();
          //that.map.addLayer(L.marker(latLng));
          var m = L.marker(latLng, {
              icon: defIcon
            }).bindPopup(that.renderMarker(model))
            .on("click", function (e) {
              //if(window.i<2) {                
                map.setView(e.target.getLatLng(), 18/*map.getZoom()+1/*10*/);
              //}
              //var latLngs = [ e.target.getLatLng() ];			
              //var markerBounds = L.latLngBounds(latLngs);
              //debugger
              //map.fitBounds(markerBounds);
            })
            .on("popupopen", popupOpen)
            .on("popupclose", function () {
              if(this._icon) this.setIcon(defIcon);
              else { 
                // reset all markers icons of parent group (should work always)		  
                var markers = this.__parent.getAllChildMarkers();
                _.each(markers,function(marker) {
                  //console.log(marker.options.icon.options.className);
                  marker.options.icon = defIcon;
                });
              }
              closePopup();         
            });

          locationsPoints[title] = {
            latLng: latLng,
            m: m
          };

          markersList.push(m);
          clusterGroups.addLayer(m);
          clusterGroups["points"] = true; // set "marker" for clusterGroups-layer

          clusterGroups.on("clusterclick",function(a) {
            if(_.uniq(_.pluck(a.layer.getAllChildMarkers(),"_latlng"),function(e) { return e.lat + " " + e.lng; }).length === 1) {				  
              that.map.setView(a.layer.getLatLng(), 17);
              window.noZoomOrSpiderify = true;
            }
          });

          //clusterGroups[region].addLayer(L.marker(latLng));

          //L.marker(latLng).addTo(clusterGroups[region]);
          //if (!window.executeSearch)
          that.latLngBounds.extend(latLng);
        }

      });

      // clear up old layers before adding actual layer (inefficient)
      that.map.eachLayer(function (layer) {
        if (layer.points) that.map.removeLayer(layer);
      });
      
      that.map.addLayer(clusterGroups);

      if (visible) {
        if (!window.executeSearch)
          this.map.fitBounds(that.latLngBounds.pad(0.15));
      } else {
        this.hide();
      }
    } catch (e) {
      console.log(e);
    }

    if (!moveendSet) {
      moveendSet = true;
      map.on('moveend', moveend);
    }

  }

});